import React, { useEffect, useState } from "react";
import PropTypes from 'prop-types';
import { Link, useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";
import { useDispatch } from "react-redux";
import { useFormik } from "formik";
import { resetPassFormValidator } from "../../../services/validatior/formValidator/authValidator";
import { resetPassword } from "../../../redux/reducers/authSlice";

const PasswordReset = () => {
  const [isPwdShown, setIsPwdShown] = useState(true);
  const [isPwdShw, setIsPwdShw] = useState(true);
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const location = useLocation()
  // const [searchParams] = useSearchParams()
  // let token = searchParams.get('token')


  // const {token}=useParams()
  const gotoLogin = () => {
    navigate("/login");
  };
  const resetPassFormik = useFormik({
    initialValues: resetPassFormValidator.initialValues,
    validationSchema: resetPassFormValidator.validationSchema,
    onSubmit: (values) => {
      let data = { password: values?.newPassword, otp: location?.state }
      dispatch(resetPassword({
        apiData: data, navigate: navigate,
        // paramToken: token
      }))
    }
  })

  useEffect(() => {
    if (!location?.state) {
      navigate('/')

    }
  }, [])
  return (

    <>
      {/* Hello world */}
      <div className="authentication-wrapper authentication-basic container-p-y verify-m">
        <div className="authentication-inner  position-relative ">
          {/* Reset Password */}
          <div className="card verify-card">
            <div className="card-body">
              <div className="app-brand auth-logo">
                <img src="/assets/images/OHC-Logo.png" alt="" />
              </div>
              <div className="app-brand justify-content-start">
                <p className="app-brand-link gap-2">
                  <span className="app-brand-text demo text-body fw-bold ms-1">

                  </span>
                </p>
              </div>
              {/* /Logo */}
              <h4 className="mb-1 pt-2">Reset Password 🔒</h4>
              <p className="mb-4">
                for <span className="fw-medium">{localStorage.getItem("emailForGotPass")}</span>
              </p>
              <form onSubmit={resetPassFormik.handleSubmit}>
                <div className="mb-3 form-password-toggle">
                  <label className="form-label" htmlFor="password">
                    New Password
                  </label>
                  <div className="input-group input-group-merge">
                    <input
                      type={isPwdShown ? "password" : "text"}
                      id="password"
                      className="form-control"
                      name="newPassword"
                      placeholder="············"
                      aria-describedby="password"
                      value={resetPassFormik?.values.newPassword} onChange={resetPassFormik.handleChange}
                    />

                    <span className="input-group-text cursor-pointer">
                      <FontAwesomeIcon
                        icon={
                          isPwdShown
                            ? icon({ name: "eye-slash" })
                            : icon({ name: "eye" })
                        }
                        onClick={() => setIsPwdShown(!isPwdShown)}
                      />
                    </span>

                  </div>
                  <p className='form-error-message'>{resetPassFormik.touched.newPassword &&
                    resetPassFormik.errors.newPassword}</p>
                </div>
                <div className="mb-3 form-password-toggle">
                  <label className="form-label" htmlFor="confirm-password">
                    Confirm Password
                  </label>
                  <div className="input-group input-group-merge">
                    <input
                      type={isPwdShw ? "password" : "text"}
                      id="confirm-password"
                      className="form-control"
                      name="confrmPassword"
                      placeholder="············"
                      aria-describedby="password"
                      value={resetPassFormik?.values.confrmPassword} onChange={resetPassFormik.handleChange}
                    />

                    <span className="input-group-text cursor-pointer">
                      <FontAwesomeIcon
                        icon={
                          isPwdShw
                            ? icon({ name: "eye-slash" })
                            : icon({ name: "eye" })
                        }
                        onClick={() => setIsPwdShw(!isPwdShw)}
                      />
                    </span>
                  </div>
                  <p className='form-error-message'>{resetPassFormik.touched.confrmPassword &&
                    resetPassFormik.errors.confrmPassword}</p>
                </div>
                <button className="btn w-100 mb-3">
                  Set new password
                </button>
                <div className="text-center back-log">
                  <Link to="/login" className='colour-red'>
                    <FontAwesomeIcon icon={icon({ name: "angle-left" })} />
                    Back to login

                  </Link>
                </div>
              </form>
            </div>
          </div>

        </div>
      </div>
    </>



  );
};




export default PasswordReset;
